import React, { useMemo } from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import { charleyMemoryConfig } from './config';
import qrFrame from './assets/qr-frame.png';

const targetPath = charleyMemoryConfig.routePath; // '/charley-memory'

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 100px 20px 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fffaf3;
  color: #4a3838;

  @media print {
    min-height: auto;
    padding: 24px;
    background: #fffaf3;
    color: #111;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;

const Card = styled.div`
  display: inline-block;
`;

const Frame = styled.div`
  position: relative;
  display: inline-block;
`;

const FrameImage = styled.img`
  display: block;
  width: 420px;
  height: auto;

  @media print {
    width: 380px;
  }
`;

const QRSlot = styled.div`
  position: absolute;
  top: 48%;
  right: 40px;
  transform: translateY(-50%);
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  margin-top: 32px;
  max-width: 420px;
  line-height: 1.7;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.78);

  p {
    margin: 0 0 0.75em;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }

  @media print {
    margin-top: 24px;
    color: #111;
  }
`;

const Signature = styled.p`
  margin: 8px 0 0;
  text-align: right;
`;

const CharleyMemoryQRCodePage = () => {
  const targetUrl = useMemo(() => {
    if (typeof window === 'undefined') return '';
    return `${window.location.origin}${targetPath}`;
  }, []);

  return (
    <PageContainer>
      <Card>
        <Frame>
          <FrameImage src={qrFrame} alt="" />
          <QRSlot>
            <QRCodeSVG
              value={targetUrl}
              size={180}
              level="M"
              includeMargin={false}
              bgColor="transparent"
            />
          </QRSlot>
        </Frame>
      </Card>
      <Message>
        <p>
          非洲菊的花語是
          <br />
          「永遠快樂、堅強、熱情與追求美好」
        </p>
        <p>
          希望和查理在一起的日子，
          <br />
          是開心的，是有熱情的，
          <br />
          是一起追求美好、一起成長、一起變得更好的。
        </p>
        <Signature>不太聰明但有傻勁的大祐</Signature>
      </Message>
    </PageContainer>
  );
};

export default CharleyMemoryQRCodePage;
